const outlineColorOptions = {
  blue: 'outline-blue',
  darkBlue: 'outline-dark-blue',
  transparent: 'outline-transparent'
};

export { outlineColorOptions };
//# sourceMappingURL=outlineColorOptions.js.map
